import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MATERIAL_MODULES } from '@shared/material';
import { IviConnectionsComponent } from './ivi-connections.component';

// Kept out of SharedModule's own declarations on purpose (see AiAssistButtonModule for the same
// pattern / the DEV-3829 SharedModule JIT circular-import trap): this dialog only depends on
// AssistantService (a plain `@core` HTTP service) plus Angular Material, so it carries no risk of
// pulling `@modules/*` back into SharedModule's dependency graph. It's imported into
// SharedModule's `imports` (not `declarations`/`exports`) purely so it's part of the compiled
// module graph for AiAssistantComponent's `MatDialog.open(IviConnectionsComponent, …)` call.
@NgModule({
    imports: [CommonModule, FormsModule, ...MATERIAL_MODULES],
    declarations: [IviConnectionsComponent],
    exports: [IviConnectionsComponent]
})
export class IviConnectionsModule {}
